<template>
  <FeatureDetailPage feature-key="mobile-app" />
</template>
